<template>
  <section class="pdf-item" v-if="products.length">
    <div class="block w-auto px-3 py-2 my-6 mb-1 bg-gray-200 rounded-md">
      <div class="block w-full text-lg font-bold">{{ titleLabel }} {{ titleCode }}</div>
      <div v-if="isBaseProduct" class="block w-full text-sm text-gray-600">
        <div v-if="capacities.length > 0" class="block w-ful">
          <div
            v-for="capacity in capacities"
            :key="capacity.label"
            class="block w-full mt-1 mr-1"
          >
            {{ capacity.label }}
          </div>
        </div>
        <div class="block w-full mt-1">
          <strong
            >{{ $t("common.maintananceIntervall") }}:
            {{ apiData.label }}</strong
          >
          <span v-if="apiData.intervals[0]">
            | {{ $t("common.intervals") }}: {{ apiData.intervals[0].intervals }}
          </span>
        </div>
      </div>
    </div>
    <pdf-table :products="products" />
  </section>
</template>

<script>
import PdfTable from '@/components/print//PdfTable.vue';
export default {
  components: { PdfTable },
  props: {
    isBaseProduct: {
      type: Boolean,
      default: false
    },
    apiData: {
      required: true,
      type: Object
    },
    titleLabel: {
      type: String
    },
    titleCode: {
      type: String
    },
    capacities: {
      type: Array
    }
  },
  computed: {
    products () {
      let products = this.apiData.products || this.apiData.use[0].products;
      products = products.filter(product => product.fromDB);
      return products;
    }
  }
};
</script>
